import React, { Component } from 'react';
import logo from '../assets/logo.png';  // Importing the logo
import logo2 from '../assets/logo2.png';

import './CSS/SecretPage.css';  // Assuming you have a CSS file for styling

class KeysGenerator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      publicKey: '',
      privateKey: '',
    };
  }

  // Function to convert ArrayBuffer to base64 string for PEM format
  arrayBufferToBase64 = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    bytes.forEach((b) => (binary += String.fromCharCode(b)));
    return window.btoa(binary);
  };

  // Function to format the key in PEM format
  formatPEM = (base64, type) => {
    const formattedKey = base64.match(/.{1,64}/g).join('\n');
    const pemKey = `-----BEGIN ${type} KEY-----\n${formattedKey}\n-----END ${type} KEY-----\n`;
    return pemKey;
  };

  // Function to generate RSA key pair
  generateKeys = async () => {
    try {
      const keyPair = await window.crypto.subtle.generateKey(
        {
          name: 'RSA-OAEP',
          modulusLength: 2048,
          publicExponent: new Uint8Array([1, 0, 1]),
          hash: 'SHA-256',
        },
        true,
        ['encrypt', 'decrypt']
      );

      // Export the public key
      const publicKeyBuffer = await window.crypto.subtle.exportKey('spki', keyPair.publicKey);
      const publicKeyBase64 = this.arrayBufferToBase64(publicKeyBuffer);
      const publicKeyPEM = this.formatPEM(publicKeyBase64, 'PUBLIC');

      // Export the private key
      const privateKeyBuffer = await window.crypto.subtle.exportKey('pkcs8', keyPair.privateKey);
      const privateKeyBase64 = this.arrayBufferToBase64(privateKeyBuffer);
      const privateKeyPEM = this.formatPEM(privateKeyBase64, 'PRIVATE');

      // Set keys in state
      this.setState({
        publicKey: publicKeyPEM,
        privateKey: privateKeyPEM,
      });
    } catch (err) {
      console.error('Error generating keys:', err);
    }
  };

  // Function to download keys as a .pem file
  downloadKey = (key, type) => {
    const blob = new Blob([key], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${type}_KEY.pem`;
    a.click();
  };

  // Function to copy key to clipboard
  copyToClipboard = (key) => {
    navigator.clipboard.writeText(key).then(() => {
      alert('Key copied to clipboard!');
    }).catch(err => {
      console.error('Failed to copy key:', err);
    });
  };

  render() {
    return (
      <div className="container mt-4 text-center">
        <img className='logo mb-4' src={logo} alt="Logo" />  {/* Main logo at the top */}

        <h2>RSA Key Pair Generator</h2>

        <button className="btn btn-primary mb-4" onClick={this.generateKeys}>
          Generate Key Pair
        </button>

        {this.state.publicKey && (
          <div className="mt-4">
            <h3>Public Key</h3>
            <textarea
              className="form-control"
              rows="10"
              readOnly
              value={this.state.publicKey}
            ></textarea>
            <button
              className="btn btn-success mt-2"
              onClick={() => this.downloadKey(this.state.publicKey, 'PUBLIC')}
            >
              Download Public Key
            </button>
            <button
              className="btn btn-secondary mt-2 ml-2"
              onClick={() => this.copyToClipboard(this.state.publicKey)}
            >
              Copy Public Key
            </button>
          </div>
        )}

        {this.state.privateKey && (
          <div className="mt-4">
            <h3>Private Key</h3>
            <textarea
              className="form-control"
              rows="10"
              readOnly
              value={this.state.privateKey}
            ></textarea>
            <button
              className="btn btn-success mt-2"
              onClick={() => this.downloadKey(this.state.privateKey, 'PRIVATE')}
            >
              Download Private Key
            </button>
            <button
              className="btn btn-secondary mt-2 ml-2"
              onClick={() => this.copyToClipboard(this.state.privateKey)}
            >
              Copy Private Key
            </button>
          </div>
        )}

        <div className="text-center mt-5">
          <div>Powered by</div>
      
          <img className='logo2' src={logo2} alt="Logo 2" />  {/* Third logo */}
        </div>
      </div>
    );
  }
}

export default KeysGenerator;
